export default __webpack_public_path__ + "static/media/Comentarios-orange.72b05305.svg";